import { ApolloLink } from '@apollo/client';

import { BundleBasketFragment } from '@generated/gql/graphql';

const extractBasketFromMutationResult = (
  results: Array<ApolloLink.Result | undefined>
): Nullable<BundleBasketFragment> => {
  if (!results || results.length === 0) {
    return null;
  }

  const firstResult = results[0];

  if (!firstResult?.data || firstResult.errors) {
    return null;
  }

  const { data } = firstResult;

  if ('updateEnergyQuoteRequirements' in data) {
    return data.updateEnergyQuoteRequirements as BundleBasketFragment;
  }

  if ('selectEnergyQuotes' in data) {
    return data.selectEnergyQuotes as BundleBasketFragment;
  }

  return null;
};

export { extractBasketFromMutationResult };
